import { render, staticRenderFns } from "./ParentTravelDeclaration.vue?vue&type=template&id=15c54cf0&scoped=true"
import script from "./ParentTravelDeclaration.vue?vue&type=script&lang=js"
export * from "./ParentTravelDeclaration.vue?vue&type=script&lang=js"
import style0 from "./ParentTravelDeclaration.vue?vue&type=style&index=0&id=15c54cf0&prod&scoped=true&lang=css"
import style1 from "./ParentTravelDeclaration.vue?vue&type=style&index=1&id=15c54cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c54cf0",
  null
  
)

export default component.exports